import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  getAllCustomer,
  blockCustomer,
  unBlockCustomer,
  searchCustomer,
  getCustomersByStatus,
} from "services/admin/userService";
import { PacmanLoader } from "react-spinners";
import { Button } from "rsuite";
import Swal from "sweetalert2";
import "./style.scss";
import { MenuItem, Pagination, Select } from "@mui/material";
import { introspective } from "services/tokenService";

const CustomerList = () => {
    const { slug } = useParams(); // Lấy slug từ URL
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const token = localStorage.getItem("token");
  const [customers, setCustomers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusVal, setStatusVal] = useState(0); // status của select
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
   const [page, setPage] = useState(Number(searchParams.get('page') || 1));
  const [searchText, setSearchText] = useState(searchParams.get("q") || '');
  const query = searchParams.get("q")

  const [customerPermission, setCustomerPermission] = useState(""); // lưu xem có quyền qly sách không
  
  useEffect(() => {
      const fetchPermissions = async () => {
          try {
              const response = await introspective(token);
              if (response.data) {
                setCustomerPermission(response.data.permissions.some(permission => permission.id === 4)); // id 4 là khách hàng
              }
          } 
          catch (error) {
              console.log("introspective failed:", error);
          } 
      };

      fetchPermissions();

  }, [token]);
  console.log(customerPermission)


  // getAllAdmins
  useEffect(() => {
      // if (permissionVal === 0) {
      if (slug === "all") {
          const fetchAllCustomers = async () => {
              setIsLoading(true)
              try {
                  const response = await getAllCustomer(token, page - 1);
                  if (response && response.data) {
                      setCustomers(response.data.content);
                      setTotalPages(response.data.page.totalPages);
                  }
              } 
              catch (error) {
                  console.error("fetchAllAdmins", error);
              } 
              finally {
                  setIsLoading(false);
              }
              
          };
          fetchAllCustomers();
      }
  }, [statusVal, page, token, slug]);
  console.log(customers)

  //getAdminsByPermission
  useEffect(() => {
    const fetchCustomersByStatus = async () => {
      if (slug === "unblocked") {
          setStatusVal(1);
          setIsLoading(true)
          try {
              const response = await getCustomersByStatus(token, false, page - 1);
              if (response && response.data) {
                  setCustomers(response.data.content);
                  setTotalPages(response.data.page.totalPages);
              }
          } 
          catch (error) {
              console.error("fetchCustomersByStatus", error);
          } 
          finally {
              setIsLoading(false);
          }
      }
      else if (slug === "blocked") {
          setStatusVal(2);
          setIsLoading(true)
          try {
              const response = await getCustomersByStatus(token, true, page - 1);
              if (response && response.data) {
                  setCustomers(response.data.content);
                  setTotalPages(response.data.page.totalPages);
              }
          } 
          catch (error) {
              console.error("fetchCustomersByStatus", error);
          } 
          finally {
              setIsLoading(false);
          }
      }
    }
    fetchCustomersByStatus();
    
    window.scrollTo(0, 0);
  }, [slug, page, token]);

  useEffect(() => {
      if (slug === "search") {
          const fetchCustomersBySearch = async () => {
              setIsLoading(true)
              try {
                  const response = await searchCustomer(token, searchText.trim(), page - 1)
                  if (response && response.data && response.data.content && response.data.page) {
                      setCustomers(response.data.content);
                      setTotalPages(response.data.page.totalPages);
                  }
              } 
              catch (error) {
                  console.log("fetchCustomersBySearch", error)
              }
              finally {
                  setIsLoading(false)
              }
              
          };
          fetchCustomersBySearch();
      }
  }, [page, token, slug, query]);

  const handleChangeStatus = (event) => {
    setStatusVal(event.target.value);
  };

   const handlePermissionClick = (id) => {
      if (id === 0) {
        setStatusVal(id);
        navigate(`/admin/list-customer/all`);
        setPage(1)
      }
      else if (id === 1) {
          // const permission = permissions.find(permission => permission.id === id);
          // const slug = generateSlug(permission.name); 
        setStatusVal(id);
        navigate(`/admin/list-customer/unblocked`);
        setPage(1)
      }
      else {
        setStatusVal(id);
        navigate(`/admin/list-customer/blocked`);
        setPage(1)
      }
  };

  const handlePageChange = (event, value) => {
    if (slug === "all") {
        setPage(value);
        navigate(`/admin/list-customer/all?page=${value}`);
    }
    else if (slug === "search") {
        setPage(value);
        navigate(`/admin/list-customer/search?q=${searchText.trim()}&page=${value}`);
    }
    else if (slug === "unblocked") { 
        setPage(value);
        navigate(`/admin/list-customer/unblocked?page=${value}`);
    }
    else if (slug === "blocked") {
        setPage(value);
        navigate(`/admin/list-customer/blocked?page=${value}`);
    }
  };

  const handleToggleBlock = async (customerEmail, isBlocked) => {
    const action = isBlocked === false ? "khóa" : "mở khóa";

    Swal.fire({
      title: `Xác nhận ${action} tài khoản`,
      text: `Bạn có chắc chắn muốn ${action} tài khoản của người dùng này không?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Đồng ý",
      cancelButtonText: "Hủy",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          if (isBlocked === false) {
            const response = await blockCustomer(token, customerEmail);
            console.log(`Khóa tài khoản: ${customerEmail}`);
          } else {
            await unBlockCustomer(token, customerEmail);
            console.log(`Mở khóa tài khoản: ${customerEmail}`);
          }

          Swal.fire({
            title: "Thành công",
            text: `Tài khoản đã ${action} thành công.`,
            icon: "success",
          });

          setCustomers((prevCustomers) =>
            prevCustomers.map((customer) =>
              customer.email === customerEmail
                ? { ...customer, isBlocked: !isBlocked }
                : customer
            )
          );
        } catch (error) {
          console.error("Error toggling block status:", error);
          Swal.fire({
            title: "Lỗi",
            text: `Không thể ${action} tài khoản. Vui lòng thử lại sau.`,
            icon: "error",
          });
        }
      } else {
        console.log("Hành động bị hủy");
      }
    });
  };

//   const handleSearchChange = (e) => {
//     const text = e.target.value;
//     setSearchText(text);
// };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);  // Cập nhật giá trị tìm kiếm khi người dùng nhập
  };

  const handleKeyDownSearch = (event) => {
      if (event.key === "Enter") {
        navigate(`/admin/list-customer/search?q=${searchText.trim()}`)
        setStatusVal(0)
        setPage(1)
      }
  }

  return (
    <>
      <div className="CustomerList">
        <div className="card border-0 p-4 mt-5 mb-5">
          <div className="headCard d-flex">
            <h5 className="mb-3">Tất cả khách hàng</h5>
          </div>
          <hr />
          
          <div className="row cardFilters">
            <div className="col-4">
                  <h4>Trạng thái</h4>
                  <Select
                      className="custom-select"
                      value={statusVal}
                      onChange={handleChangeStatus}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      MenuProps={{
                          disableScrollLock: true,
                          PaperProps: {
                              style: {
                                  maxHeight: 200, 
                                  overflowY: 'auto',
                              },
                          },
                      }}
                      sx={{
                          '&.MuiOutlinedInput-root': {
                              // '& fieldset': {
                              //     borderColor: 'red',
                              // },
                              '&:hover fieldset': {
                                  borderColor: '#9d2ff7',
                              },
                              '&.Mui-focused fieldset': {
                                  borderColor: '#9d2ff7',
                              },
                          },
                      }}
                  >
                      <MenuItem disabled>
                          <em></em>
                      </MenuItem>

                      <MenuItem value={0} onClick={() => handlePermissionClick(0)} >Tất cả người dùng</MenuItem>

                      <MenuItem value={1} onClick={() => handlePermissionClick(1)} >Đang hoạt động</MenuItem>

                      <MenuItem value={2} onClick={() => handlePermissionClick(2)} >Bị khoá</MenuItem>
                  </Select>
              </div>
              <div className="col-8">
                  <h4>Tìm kiếm</h4>
                  <input 
                      type="text" 
                      value={searchText}
                      placeholder="Search...!!!" 
                      onChange={handleSearchChange} 
                      onKeyDown={handleKeyDownSearch}
                  />
              </div>
          </div>
          <hr />

          <div className="table-responsive mt-3">
            <table className="table table-bordered v-align">
              <thead className="thead-dark">
                <tr>
                  <th>STT</th>
                  <th>TÊN KHÁCH HÀNG</th>
                  <th>SỐ ĐIỆN THOẠI</th>
                  <th>EMAIL</th>
                  <th>ĐƠN GIAO THÀNH CÔNG</th>
                  <th>ĐƠN ĐÃ BOOM</th>
                  <th>ĐÁNH GIÁ BỊ TỪ CHỐI</th>
                  <th>ACTION</th>
                </tr>
              </thead>

              <tbody>
                {customers.length > 0 ? (
                  customers.map((customer, index) => (
                    <tr key={customer.fullName}>
                      <td>{index + 1}</td>
                      <td>{customer.fullName}</td>
                      <td>{customer.phoneNumber || "Không có SDT"}</td>
                      <td>{customer.email}</td>
                      <td>{customer.completedOrders}</td>
                      <td>{customer.rejectedOrders}</td>
                      <td>{customer.rejectedReviews}</td>
                      <td>
                        <button
                          className={
                            customer.isBlocked ? "btn-green" : "btn-red"
                          }
                          onClick={() => {
                            if (!customerPermission) {
                              Swal.fire({
                                title: "Không có quyền",
                                text: "Bạn không có quyền thực hiện hành động này.",
                                icon: "error",
                              });
                            }
                            else {
                              handleToggleBlock(
                                customer.email,
                                customer.isBlocked
                              )
                            }
                          }
                          }
                        >
                          {customer.isBlocked ? "Mở khóa" : "Khóa tài khoản"}
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      Không có khách hàng nào
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="d-flex tableFooter">
              <Pagination 
                  className="ms-auto" 
                  count={totalPages} 
                  color="secondary"
                  page={page} 
                  onChange={handlePageChange}
              />
            </div>
            {isLoading && (
              <div className="modal">
                <div className="overlay_loading">
                  <div className="modal-content_loading">
                    <div className="d-flex">
                      <PacmanLoader color="#5e2e86" />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerList;
